module.exports = __webpack_public_path__ + "img/icn_check_tearai.80ae0d8a.png";